module.exports = __webpack_public_path__ + "media/images/t-justice-design-square-21fd7edcdc7d5eb29c05de615674e453.png";